module.exports = __webpack_public_path__ + "img/search_save_icon.4288b906.svg";